
export default function ValidationsCompliance() {

    const validateFields = (fields) => {
        const {
            descricao
        } = fields;
        const errors = {};
        
      
        if (!descricao || !descricao.trim()) {
            errors.descricao = "O campo Descrição é obrigatório.";
        }
       
        return errors;
    };

    return {
        validateFields
    }
}